import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../../common_components/StaticFooter";
import StaticHeader from "../../common_components/staticHeader";
import $ from 'jquery'
import { BASE_URL, toastError } from "../../../../utils/constants";
import { getActiveJuryDetails_action } from "../../../../actions/static_action/currentAwardDetails_action";
import { Modal } from "react-bootstrap";

class Jury extends Component {
    constructor(props) {
        super(props);
        this.state = {
            speakers: [],
            JuryName: '',
            JuryPDF: '',
            isOpen: '',
            cmsSectionData: [], cmsMenuData: [], cmsFooterData: []
        }
    }

    componentDidMount() {
        this.loadscript()
        this.getActiveJuryDetails()
        
    }

    getActiveJuryDetails() {
        this.setState({ isLoading: true });
        const award_event_id = sessionStorage.getItem("award_event_id")

        this.props
            .getActiveJuryDetails_action(
                award_event_id != "" ? award_event_id : null
            )
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != "") {
                        const filterArray = []
                        data.data.map((item => {
                            filterArray.push(
                                {
                                    name: item.name,
                                    role: item.designation,
                                    company_name: item.company_name,
                                    imgSrc: item.profile_image != null ? BASE_URL.split('/api')[0] + item.profile_image : null,
                                    juryDetailsPdf: item.profile_filepath != null ? BASE_URL.split('/api')[0] + item.profile_filepath : null
                                }
                            )
                        }))
                        this.setState({
                            isLoading: false,
                            speakers: filterArray
                        });
                    } else {
                        this.setState({
                            isLoading: false,
                        });
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }


    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }
    render() {
        const { speakers,
            JuryName,
            JuryPDF,
            isOpen } = this.state;
        return (
            <>
                <StaticHeader />
                <>
                    <div className="website">
                        <section className="banner page-banner position-relative pb-0">
                            <div className="overlay"></div>
                            <div className="container">
                                <div className="page-title text-center position-relative py-9">
                                    <h2 className="text-white text-uppercase mt-4">Our Jury</h2>
                                </div>
                            </div>
                        </section>
                        <section className="conference">
                            <div className="container">
                                <div className="conference-inner text-center">

                                    <div className="app">
                                        <div className="speaker-grid">
                                            {speakers.map((speaker, index) => (
                                                <div key={index} className="speaker-card">
                                                    <div className="image-container-outline">
                                                        <div className="image-container">
                                                            {console.log("speaker.juryDetailsPdf-->", speaker.juryDetailsPdf)}
                                                            {speaker.imgSrc != '' && speaker.imgSrc != null ?
                                                                <img
                                                                    src={speaker.imgSrc}
                                                                    alt={speaker.name}
                                                                    onClick={() => speaker.juryDetailsPdf != null && this.setState({
                                                                        JuryPDF: speaker.juryDetailsPdf, isOpen: true, JuryName: speaker.name
                                                                    })}
                                                                    className="speaker-image"
                                                                /> :
                                                                <img
                                                                    src={"img/profile_img.png"}
                                                                    alt="Profile Preview"
                                                                    className="rounded-circle profile-pic"
                                                                    width="170"
                                                                    height="165"
                                                                    onClick={() => speaker.juryDetailsPdf != null && this.setState({
                                                                        JuryPDF: speaker.juryDetailsPdf, isOpen: true, JuryName: speaker.name
                                                                    })}
                                                                />
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="social-icons">
                                                        <a href="#" className="icon">
                                                            <i class="ri-facebook-line"></i>
                                                        </a>
                                                        <a href="#" className="icon">
                                                            <i class="ri-twitter-line"></i>
                                                        </a>
                                                        <a href="#" className="icon">
                                                            <i class="ri-instagram-line"></i>
                                                        </a>
                                                        <a href="#" className="icon">
                                                            <i class="ri-linkedin-line"></i>
                                                        </a>
                                                    </div>
                                                    <h3 className="speaker-name">{speaker.name}</h3>
                                                    <p className="speaker-company">{speaker.company_name}</p>
                                                    <p className="speaker-role">{speaker.role}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </>

                <Modal show={this.state.isOpen} size="xl">
                    <Modal.Header>
                        <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                            {/* <div > */}
                            <h6> {JuryName} </h6>
                            {/* </div> */}
                        </Modal.Title>
                        <span
                            onClick={() => this.setState({ isOpen: false })}
                            style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                        >
                            X
                        </span>
                    </Modal.Header>
                    <Modal.Body>
                        <iframe
                            id="myIframe"
                            // src={`/${sessionStorage.getItem("sessionExhibitionID")}/Rules-and-Regulations.pdf#toolbar=0&navpanes=0`}
                            src={`${JuryPDF}#toolbar=0&navpanes=0`}
                            // src={`${juryDetailsPdf}`}
                            width="100%"
                            height="450px"
                            title="Bing"
                        >
                            &lt;/div&gt; &lt;div style="height: 100px;"&gt;&lt;/div&gt;
                            &lt;/div&gt; &lt;/div&gt; &lt;/div&gt;
                        </iframe>
                    </Modal.Body>

                    <Modal.Footer style={{ justifyContent: 'right' }}>
                        <div class="row">
                            <div class="col-md-12">
                                <button
                                    onClick={() => this.setState({ isOpen: false })}
                                    class="btn btn-dark"
                                    style={{ cursor: 'pointer', width: 'auto' }}
                                >
                                    Back
                                </button>
                            </div>
                        </div>

                    </Modal.Footer>
                </Modal>
                <StaticFooter />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, { getActiveJuryDetails_action })(Jury)
);
